export default "__VITE_ASSET__2aa81765__"